import { differenceInYears } from 'date-fns';

import { ADULT_MINIMUM_AGE } from './constants';

export function calculateAge(birthday: Date): number {
  return differenceInYears(new Date(), birthday);
}

export function hasMinimumAge(birthday: Date, minimumAgeInYears: number): boolean {
  return calculateAge(birthday) >= minimumAgeInYears;
}

export function isAdult(birthday: Date): boolean {
  return hasMinimumAge(birthday, ADULT_MINIMUM_AGE);
}
